<template>
  <b-modal
      id="technician-delete-modal"
      :title="'Supprimer ' + $t('a.technician')"
      @ok="handleOk"
      :ok-title="$t('Delete')"
      ok-variant="danger"
      :cancel-title="$t('Cancel')"
      cancel-variant="danger"
      :hide-footer="!canBeDeleted"
  >
    <div v-if="!!selectedTechnician">
      <div v-if="canBeDeleted">
        {{ $t('Delete') }} {{ $t('l.technician') }} "{{ selectedTechnician.firstName + ' ' + selectedTechnician.lastName }}" ?
      </div>
      <div v-else>
        Le technicien {{ selectedTechnician.firstName + ' ' + selectedTechnician.lastName }} ne peut pas être supprimé car il a des interventions associés
      </div>
    </div>
  </b-modal>
</template>

<script>

import api from '../../services/api';

export default {

  name: 'TechnicianDeleteModal',

  props: {
    selectedTechnician: Object
  },

  emits: ['didDeleteTechnician'],

  data() {
    return {
      canBeDeleted: false
    }
  },

  watch: {
    'selectedTechnician': function () {
      this.checkDelete()
    }
  },

  methods: {

    checkDelete() {
      this.canBeDeleted = false
      if (this.selectedTechnician) {
        api
            .get(`/technician/countInterventionByTechnicianId?technicianId=${this.selectedTechnician.id}`)
            .then(response => {
              this.canBeDeleted = response.data.count === 0
            })
      }
    },

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault() // Prevent modal from closing
      this.handleSubmit()
    },

    handleSubmit() {
      let technicianName = this.selectedTechnician.firstName + " " + this.selectedTechnician.lastName

      api
          .delete(`/technician/${this.selectedTechnician.id}`)
          .then(response => {
            this.$emit('didDeleteTechnician')
            this.hideModal()
            this.successToast(this.$i18n.t('Technician') + ' "' + technicianName + '" ' + this.$i18n.t('deleted'))
          })
          .catch((error) => {
            if (error.response.status === 418) {
              this.$bvToast.toast(error.response.data.message, {
                autoHideDelay: 2000,
                toaster: 'b-toaster-bottom-right'
              })
            }
          });
    },

    hideModal() {
      this.$bvModal.hide('technician-delete-modal')
    },

    successToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/technician/TechnicianDeleteModal.vue